module.exports = __webpack_public_path__ + "img/theme10.7ec8545c.png";